<template>
  <div class="legend" :class="{'is-visible': isVisible}">
    <div
      class="legend__img u-flex u-top"
      :class="transformation.y > 0 ? 'u-bottom' : 'u-top'"
      :style="{top: transformation.y === -1 ? '-10px' : '4px', left: transformation.x === -1 ? '-10px' : '4px'}"
    >
      <img :src="src" class="u-full-width">
    </div>
  </div>
</template>

<script>
import Object3d from '@/plugins/Dom3d/mixin'

export default {
  mixins: [Object3d],

  props: {
    src: {
      type: String,
      default: ''
    },
    isVisible: {
      type: Boolean,
      default: false
    }
  }
}

</script>

<style lang="stylus">

.legend
  width 4px
  height 4px
  opacity 0
  transition opacity 1s linear
  
  &.is-visible
    opacity 1
    transition opacity 1s 1s linear
  
  &__img
    width 10px
    height 10px
    position absolute
    top 0
    left 0

</style>